"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
}
Object.defineProperty(exports, "__esModule", { value: true });
var TrackEntry_1 = require("./TrackEntry");
Object.defineProperty(exports, "TrackEntry", { enumerable: true, get: function () { return TrackEntry_1.default; } });
var useMaybeTrackEvent_1 = require("./hooks/useMaybeTrackEvent");
Object.defineProperty(exports, "useMaybeTrackEvent", { enumerable: true, get: function () { return useMaybeTrackEvent_1.default; } });
var useTrackEntry_1 = require("./hooks/useTrackEntry");
Object.defineProperty(exports, "useTrackEntry", { enumerable: true, get: function () { return useTrackEntry_1.default; } });
var useTrackEvent_1 = require("./hooks/useTrackEvent");
Object.defineProperty(exports, "useTrackEvent", { enumerable: true, get: function () { return useTrackEvent_1.default; } });
var useTrackTime_1 = require("./hooks/useTrackTime");
Object.defineProperty(exports, "useTrackTime", { enumerable: true, get: function () { return useTrackTime_1.default; } });
var useCountClicks_1 = require("./hooks/useCountClicks");
Object.defineProperty(exports, "useCountClicks", { enumerable: true, get: function () { return useCountClicks_1.default; } });
var TrackOnChange_1 = require("./TrackOnChange");
Object.defineProperty(exports, "TrackOnChange", { enumerable: true, get: function () { return TrackOnChange_1.default; } });
var TrackTime_1 = require("./TrackTime");
Object.defineProperty(exports, "TrackTime", { enumerable: true, get: function () { return TrackTime_1.default; } });
var TrackingCookies_1 = require("./TrackingCookies");
Object.defineProperty(exports, "TrackingCookies", { enumerable: true, get: function () { return TrackingCookies_1.default; } });
var createEventTracker_1 = require("./createEventTracker");
Object.defineProperty(exports, "createEventTracker", { enumerable: true, get: function () { return createEventTracker_1.default; } });
__exportStar(require("./fullstory"), exports);
var TrackingContext_1 = require("./TrackingContext");
Object.defineProperty(exports, "TrackingContext", { enumerable: true, get: function () { return TrackingContext_1.TrackingContext; } });
Object.defineProperty(exports, "useTrackingContext", { enumerable: true, get: function () { return TrackingContext_1.useTrackingContext; } });
Object.defineProperty(exports, "TrackingProvider", { enumerable: true, get: function () { return TrackingContext_1.TrackingProvider; } });
var constants_1 = require("./constants");
Object.defineProperty(exports, "SIGNUP_PRE_INTENT_EVENT", { enumerable: true, get: function () { return constants_1.SIGNUP_PRE_INTENT_EVENT; } });
Object.defineProperty(exports, "TRIGGER_SCROLL_TRACKING", { enumerable: true, get: function () { return constants_1.TRIGGER_SCROLL_TRACKING; } });
Object.defineProperty(exports, "ClickIds", { enumerable: true, get: function () { return constants_1.ClickIds; } });
__exportStar(require("./trackingScope"), exports); // Middleware
var eventDebugger_1 = require("./middleware/eventDebugger");
Object.defineProperty(exports, "eventDebugger", { enumerable: true, get: function () { return eventDebugger_1.default; } });
